export default __webpack_public_path__ + "static/media/no-connection.7668515e.svg";